// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jnl6","index":"styles_index__i1JP1"};